var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuberlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 52.5,
    viewBox: "0 0 140 52.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.191,
    y1: 0.5,
    x2: 2.874,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fc9403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f4730b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb4917"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.048,
    y1: 0.5,
    x2: 3.968,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.646,
    y1: 0.5,
    x2: 1.859,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -28.649,
    y1: 0.5,
    x2: 0.98,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -30.531,
    y1: 0.5,
    x2: -0.902,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -6.33,
    y1: 0.5,
    x2: 0.433,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3.645,
    y1: 0.5,
    x2: 0.641,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.703,
    y1: 0.5,
    x2: 0.559,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -5.962,
    y1: 0.5,
    x2: -0.71,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2.172,
    y1: 0.5,
    x2: 1.22,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(-401.169 -232.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    transform: "translate(401.169 232.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M448.116,244.3h-5.5c-.17.087-.255.172-.255.257v17.566c0,.3-.023.768-.064,1.41q-1.348,5.492-6.994,5.492h-.086a13.372,13.372,0,0,1-1.475-.086q-5.519-1.326-5.518-6.816V244.561c-.086-.17-.164-.257-.235-.257H422.41q-.257.13-.257.257v14.617q0,5.6,1.07,7.885,3.657,7.885,12,7.885a13.658,13.658,0,0,0,5.668-1.155q7.485-3.654,7.485-12.564V244.561C448.288,244.391,448.2,244.3,448.116,244.3Z",
    transform: "translate(-392.218 -228.007)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M414.9,258.336l11.873-13.422a.23.23,0,0,0-.173-.382H419.1a.224.224,0,0,0-.171.077L407.42,257.488V244.761a.229.229,0,0,0-.23-.229H401.4a.229.229,0,0,0-.23.229v29.1l9.535-10.78,9.1,11.824a.226.226,0,0,0,.167.09l7.494.526a.23.23,0,0,0,.2-.369Z",
    transform: "translate(-401.169 -227.91)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M464.162,258.708a9.116,9.116,0,0,0,2.245-5.982q0-5.92-6.31-8.227a13.127,13.127,0,0,0-3.913-.577H444.414q-.128,0-.257.235v5.406h0v24.743c0,.086.084.171.257.257h12.431q8.042,0,10.48-5.9a12.629,12.629,0,0,0,.492-2.819A8.972,8.972,0,0,0,464.162,258.708Zm-7.656-8.888q3.037,0,3.742,2.243v1.581q-.492,2.651-3.487,2.65h-7.11V249.82Zm5.238,16.112q-.469,2.649-3.827,2.648h-8.266v-6.474h7.11q3.657,0,4.662,1.9a3.692,3.692,0,0,1,.321,1.176Z",
    transform: "translate(-382.832 -228.169)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 1.799,
    cy: 1.797,
    rx: 1.799,
    ry: 1.797,
    transform: "translate(101.779 48.906)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 1.799,
    cy: 1.797,
    rx: 1.799,
    ry: 1.797,
    transform: "translate(108.549 48.906)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M485.709,261.7l-15.256-.222c-.168.1-.253.184-.253.255l2.06,5.492q.126.257.253.257l13.2.224q.253-.128.253-.257v-5.492Q485.835,261.7,485.709,261.7Z",
    transform: "translate(-371.723 -220.702)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M488.433,244.3H464.067q-.253.13-.253.257l2.024,5.492q.126.235.253.235h22.341q.253-.128.253-.235v-5.492C488.6,244.391,488.517,244.3,488.433,244.3Z",
    transform: "translate(-374.447 -228.007)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M487.053,253H467.3c-.17.087-.254.172-.254.258l1.952,5.49q.126.257.253.257h17.8q.253-.15.253-.257v-5.49C487.222,253.086,487.137,253,487.053,253Z",
    transform: "translate(-373.067 -224.309)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M498.552,263.427v-.257a8.7,8.7,0,0,0,4.833-3.888,12.241,12.241,0,0,0,1.07-4.658q0-7.374-7.314-9.788a17.673,17.673,0,0,0-3.487-.428l-8.317-.352c-.086,0-.171.086-.255.257l.017,5.76c0,.07.086.148.257.234h7.806q3.465,0,4.726,2.072a3.813,3.813,0,0,1,.514,1.924v.234q0,3.912-5.24,3.911h-4.084v.086q.086.406,7.571,13.441,1.648,2.97,1.989,3.077h6.738Q505.375,274.774,498.552,263.427Z",
    transform: "translate(-365.375 -228.112)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M461.917,233.115a.381.381,0,0,0-.355-.245H448.5a.381.381,0,0,0-.381.381v.684a.379.379,0,0,0,.381.379h12.072a.378.378,0,0,1,.354.245l17.144,44.867a.38.38,0,0,0,.355.245h.74a.381.381,0,0,0,.355-.516Z",
    transform: "translate(-381.144 -232.87)",
    fill: "url(#linear-gradient-10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuberlogo);
export default __webpack_public_path__ + "static/media/kuberlogo.6a818625a848883e379289a80d2d6663.svg";
export { ForwardRef as ReactComponent };